module.exports = __webpack_public_path__ + "img/home-07-cosmo-popup-bg-01.59683b77.jpg";